var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductsScrollCarousel',{attrs:{"products":_vm.products,"card":_vm.cardComponent,"preview-only":_vm.previewOnly,"is-desktop":_vm.isDesktop,"open-in-new-tab":_vm.openInNewTab}})}
var staticRenderFns = []

export { render, staticRenderFns }